import React from 'react'
import { number } from 'prop-types'
import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'

import FireIcon from 'images/icons/svg/FireIcon'

function TrendingLabel({ numberOfTagsWithoutPenalty = 0 }) {
  return (
    <div className={classnames(
      'promote-modal__trending-label',
      numberOfTagsWithoutPenalty === 0 && 'promote-modal__trending-label--alone'
    )}
    >
      <FireIcon width={16} height={16} className="promote-modal__trending-label-icon" />
      <span className="promote-modal__trending-label-text">TRENDING TAGS</span>
      <div className="promote-modal__trending-label-divider" />
      <Tooltip
        id="trending-tooltip"
        content="Trending tags are in high demand right now, so their cost is temporarily higher than usual."
        place="left"
      >
        <Icon type={['fas', 'info-circle']} className="promote-modal__trending-tooltip-icon" />
      </Tooltip>
    </div>
  )
}

TrendingLabel.propTypes = {
  numberOfTagsWithoutPenalty: number,
}

export default TrendingLabel
